import apiClient from './apiClient';

/**
 * Get Why Choose Us CMS content
 */
export const getWhyChooseUs = async () => {
  const { data } = await apiClient.get('/api/why-choose-us');
  return data && typeof data === 'object' ? data : null;
};

/**
 * Save / Update Why Choose Us CMS content
 */
export const saveWhyChooseUs = async (payload) => {
  const { data } = await apiClient.put('/api/why-choose-us', payload);
  return data;
};
